import Typography from '@material-ui/core/Typography'

export const AccessDenied = () => (
  <>
    <Typography variant="h1">Você não possui acesso, tente relogar</Typography>
  </>
)
